import React from 'react';
import {
    useImpactModelExceedsLimit,
    useImpactModelWarning,
} from 'impactModel/impact-model-slice.ts';
import InfoBox from 'utils/components/InfoBox/InfoBox.tsx';

export function ImpactModelWarning({ message }: { message: string }) {
    const impactModelWarning = useImpactModelWarning();
    const impactModelExceedsLimit = useImpactModelExceedsLimit();

    if (impactModelWarning) {
        return (
            <InfoBox
                className="ImpactModelWarning"
                info={message}
                tooltip={impactModelWarning}
            />
        );
    }
    if (impactModelExceedsLimit) {
        return (
            <InfoBox
                className="ImpactModelWarning"
                info={'Portfolio too large for Tradespex API'}
                tooltip={impactModelWarning}
            />
        );
    }
    return <></>;
}
